export default __webpack_public_path__ + "static/media/pic10.16459f76.jpg";